<!-- 分货地址管理-->
<template>
  <div>
        <ctrl-box class="ctrl-box" :data="{}">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="list(true)">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shuaxin1" font-size="27px;"/>
                            <span class="txt" >{{msg('刷新')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="doDelete()" v-if="hasPermission('shop:delete')">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shanchu1" font-size="27px;"/>
                            <span class="txt">{{msg('删除')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('縣市')">
                        <el-input v-model="scope.query.city" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('區域')">
                        <el-input v-model="scope.query.area" ></el-input>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list(true)" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <div class="nav-tag">
                <el-tag :effect="query.typeStr==='0'?'dark':'plain'" @click="doNav('0')">东风派送区</el-tag>
                <el-tag :effect="query.typeStr==='1'?'dark':'plain'" @click="doNav('1')">通盈不送区</el-tag>
            </div>
            <vxe-grid ref="dataTable" :height="docHeight" 
                resizable border="full"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="shops"
                :columns="columns"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>
    
        <shop-order-update ref="shopOrderUpdateDialogRef" />

    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";

export default {
    name: 'deliveryAddress',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
    },
    mounted:function(){
        this.buildColumns();
        this.list();
        this.getShopQty();
    },
    data(){
        return {
            query:{
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
                city:null,
                area:null,
                typeStr:'0',
            },
            showQuery: false,
            curr: null,
            columns: [],
            shops: [],
            dgTitle: '',
            dgVisible: false,
            shopQty:0,
            changeVisible:false,
            momoVisible:false,
            coupangVisible:false,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        buildColumns(){
            this.columns = [
                {type: 'checkbox', minWidth: 60},
                {field: 'id', title: this.msg('ID'), minWidth: 80, sortable: true},
                {field: 'city', title: this.msg('縣市'), minWidth: 130, sortable: true},
                {field: 'area', title: this.msg('區域'), minWidth: 150, sortable: true},
                {field: 'created', title: this.msg('创建时间'), minWidth:130, sortable: true},
            ]
        },
        doNav(typeStr){
            this.query.typeStr = typeStr;
            if (typeStr == '0') {
                this.query.type = 0;
            }else{
                this.query.type = 1;
            }
            this.list(true);
        },
        //查询地址列表
        list(refresh){

            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
            }

            var param = this.$kit.rebuildQuery(this.query);

            this.$axios.post(this.$kit.api.deliveryAddress.list, param)
                .then((result) => {
                    if(result.status){
                        this.shops = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            var _this = this;
            this.$confirm(this.fmt('确定要删除店铺《%s》吗?', selectes.map(e => e.name)), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.shop.delete+"?ids="+selectes.map(e => e.id).join(","))
                .then((result) => {
                    _this.$message(result.msg || _this.msg('删除成功'));
                    _this.list();
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
        openedChange(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$nextTick(() => {
                this.$refs.editRateDg.init(selectes.map(s=>s.id).join(","));
            });
        },
        closeChangeDialog(){
            this.changeVisible = false;
            this.list();
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        closeEditDialog(type){  //编辑弹窗关闭后的回调事件
            if(type){
                this.list();
            }
            this.dgVisible = false;
        },
        doExport(){
            this.$refs.dataTable.exportData({ filename:"店铺信息",type: 'csv' })
        },
    },
}
</script>

<style lang="scss" scoped>
.nav-tag span{
  margin:0px 10px 5px 0px;
  cursor: pointer;
}
</style>
